import { render } from "./CodeBarre.vue?vue&type=template&id=a4af30e0"
import script from "./CodeBarre.vue?vue&type=script&lang=js"
export * from "./CodeBarre.vue?vue&type=script&lang=js"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__